<template>
  <div class="package-items">
    <div v-if="!items || items.length === 0" class="text-muted text-center py-3">
      <i class="fa fa-inbox fa-2x mb-2 d-block"></i>
      {{ $t('no_results') }}
    </div>
    <div v-else class="table-responsive">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ $t('description') }}</th>
            <th>{{ $t('solarPlantType') }}</th>
            <th>{{ $t('quantity') }}</th>
            <th>{{ $t('actions') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(packageItem, index) in items" :key="getItemKey(packageItem, index)">
            <td>
              <router-link
                v-if="packageItem.item && packageItem.item.number"
                target="_blank"
                :to="{
                  name: 'ItemEditPage',
                  params: { itemNumber: packageItem.item.number },
                }"
                >{{ packageItem.item.number.toString().padStart(4, '0') }}
                <i class="fa fa-sm fa-external-link"></i>
              </router-link>
            </td>
            <td>{{ getItemDescription(packageItem.item) }}</td>
            <td>
              <span v-if="getItemSolarPlant(packageItem.item)">
                {{ $t(getItemSolarPlant(packageItem.item)) }}
              </span>
              <span v-else class="text-muted">-</span>
            </td>
            <td>
              <div class="quantity-controls d-flex align-items-center">
                <button
                  class="btn btn-sm btn-danger"
                  @click="decreaseQuantity(index)"
                  :disabled="packageItem.quantity <= 1"
                >
                  <i class="fa fa-minus"></i>
                </button>
                <input
                  v-model.number="packageItem.quantity"
                  type="number"
                  min="1"
                  class="form-control form-control-sm mx-1 quantity-input"
                  @input="updateQuantity(index, $event.target.value)"
                />
                <button class="btn btn-sm btn-success" @click="increaseQuantity(index)">
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </td>
            <td>
              <button
                class="btn btn-sm btn-danger"
                @click="removeItem(index)"
                :title="$t('remove')"
              >
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PackageItems',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getItemKey(packageItem, index) {
      // Use item ID if available, otherwise fall back to index
      return packageItem.item?._id || packageItem.item || index;
    },
    getItemDescription(item) {
      if (typeof item === 'object' && item.description) {
        return item.description;
      }
      return '-';
    },
    getItemSolarPlant(item) {
      if (typeof item === 'object' && item.solarPlant) {
        return item.solarPlant;
      }
      return null;
    },
    increaseQuantity(index) {
      const updatedItems = [...this.items];
      const currentQuantity = parseInt(updatedItems[index].quantity || 0, 10);
      updatedItems[index] = {
        ...updatedItems[index],
        quantity: currentQuantity + 1,
      };
      this.$emit('update-items', updatedItems);
    },
    decreaseQuantity(index) {
      const currentQuantity = parseInt(this.items[index].quantity || 0, 10);
      if (currentQuantity > 1) {
        const updatedItems = [...this.items];
        updatedItems[index] = {
          ...updatedItems[index],
          quantity: currentQuantity - 1,
        };
        this.$emit('update-items', updatedItems);
      }
    },
    updateQuantity(index, newQuantity) {
      const quantity = parseInt(newQuantity) || 1;
      if (quantity >= 1) {
        const updatedItems = [...this.items];
        updatedItems[index] = {
          ...updatedItems[index],
          quantity: quantity,
        };
        this.$emit('update-items', updatedItems);
      }
    },
    removeItem(index) {
      const updatedItems = [...this.items];
      updatedItems.splice(index, 1);
      this.$emit('update-items', updatedItems);
    },
  },
};
</script>

<style scoped lang="scss">
.package-items {
  .quantity-controls {
    width: 140px;

    .quantity-input {
      width: 75px;
      text-align: right;
    }

    .btn {
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
    }
  }

  .table {
    margin-bottom: 0;

    th,
    td {
      vertical-align: middle;
    }

    .btn-sm {
      padding: 0.25rem 0.5rem;
      font-size: 0.875rem;
    }
  }
}
</style>
